import { Row, Col } from 'react-bootstrap';
import styled from '@emotion/styled';

import CONST from '../constants';
import Carousel from './Carousel';
import imgBG from '../resources/body-bg.svg';
import imgHome from '../resources/home.jpg';
import imgSlide1 from '../resources/home-slide-1.jpg';
import imgSlide2 from '../resources/home-slide-2.jpg';
import imgSlide3 from '../resources/home-slide-3.jpg';
import imgSlide4 from '../resources/home-slide-4.jpg';
import imgSlide5 from '../resources/home-slide-5.jpg';
import imgSlide6 from '../resources/home-slide-6.jpg';
import imgSlide7 from '../resources/home-slide-7.jpg';
import imgSlide8 from '../resources/home-slide-8.jpg';
import imgSlide9 from '../resources/home-slide-9.jpg';
import imgSlide10 from '../resources/home-slide-10.jpg';
import imgSlide11 from '../resources/home-slide-11.jpg';
import imgSlide12 from '../resources/home-slide-12.jpg';
import imgSlide13 from '../resources/home-slide-13.jpg';

const BREAKPOINT_LIMIT = CONST.SCREEN.BREAKPOINT.XL;

const StyledContainer = styled.div`
    position: relative;
    top: 0;
    width: 100%;
    min-height: calc(100vh - ${CONST.FOOTER_HEIGHT.MOBILE});
    margin-bottom: ${CONST.FOOTER_HEIGHT.MOBILE} !important;
    background-color: ${CONST.COLOR.BG};
    z-index: 2;
    transition: all 0.4s ease;

    @media screen and (min-width: ${CONST.SCREEN.BREAKPOINT.SM}px) {
        min-height: calc(100vh - ${CONST.FOOTER_HEIGHT.STATIC});
        margin-bottom: ${CONST.FOOTER_HEIGHT.STATIC} !important;
    }
`;

const ContentRow = styled(Row)`
    position: relative;
    margin: 0;s
    padding: 0;
    z-index: 3;
`;

const SlideRow = styled(Row)`
    position: relative;
    margin: 15vw 0 0;
    justify-content: space-around;
    background: ${CONST.COLOR.CREAM}3F;
    z-index: 3;

    @media screen and (min-width: ${CONST.SCREEN.BREAKPOINT.SM}px) {
        margin-top: 7vw;
        padding: 7vw 0;
    }

    & > p {
        display: block;
        margin: 0;
        padding: 0;
        font-size: 6vw;
        line-height: 1.75;
        color: ${CONST.COLOR.TEXT};
        text-align: center;

        @media screen and (min-width: ${CONST.SCREEN.BREAKPOINT.SM}px) {
            font-size: 2.4vw;
        }
    }
`;

const Background = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    padding: 0;
    margin: 0;
    background-position-y: 150px;
    background-image: url(${imgBG});
    background-repeat: repeat-y;
    background-size: 100%;
    box-shadow: 0 4px 6px -6px ${CONST.COLOR.THEME_SECONDARY};
    z-index: 1;
    transition: all 0.4s ease;

    @media screen and (min-width: ${CONST.SCREEN.BREAKPOINT.SM}px) {
        background-position-y: -200px;
    }
`;

const StyledImage = styled.img`
    width: 100%;
    transition: all 400ms ease;

    @media screen and (min-width: ${CONST.SCREEN.BREAKPOINT.SM}px) {
        border-radius: 0.025vw;
        box-shadow: 0 5px 5px ${CONST.COLOR.TEXT};
    }

    @media screen and (min-width: ${BREAKPOINT_LIMIT}px) {
        border-radius: ${BREAKPOINT_LIMIT * 0.0025}px;
    }

    @media screen and (min-width: ${CONST.SCREEN.BREAKPOINT.SM}px) {
        border-radius: 0 0 5px 5px;
    }
`;

const FooterText = styled.div`
    position: absolute;
    bottom: 3vw;
    right: 2vw;
    margin: 0;
    padding: 1vw 2vw;
    background: ${CONST.COLOR.BG}7F;
    border-radius: 2vw;

    @media screen and (min-width: ${CONST.SCREEN.BREAKPOINT.SM}px) {
        bottom: 0.5vw;
        right: 0.75vw;
        padding: 0.25vw 0.5vw;
        border-radius: 0.5vw;
    }

    @media screen and (min-width: ${BREAKPOINT_LIMIT}px) {
        bottom: ${BREAKPOINT_LIMIT * 0.005}px;
        right: ${BREAKPOINT_LIMIT * 0.0075}px;
        padding: ${BREAKPOINT_LIMIT * 0.0025}px ${BREAKPOINT_LIMIT * 0.005}px;
        border-radius: ${BREAKPOINT_LIMIT * 0.005}px;
    }

    & > .left {
        display: inline-block;
        margin: 0;
        padding: 1vw;
        background: ${CONST.COLOR.THEME_LIGHT};
        color: #fff;
        border-radius: 1.5vw;
        font-size: 3vw;
        vertical-align: middle;

        @media screen and (min-width: ${CONST.SCREEN.BREAKPOINT.SM}px) {
            padding: 0.5vw;
            border-radius: 0.5vw;
            font-size: 1.25vw;
        }

        @media screen and (min-width: ${BREAKPOINT_LIMIT}px) {
            padding: ${BREAKPOINT_LIMIT * 0.005}px;
            border-radius: ${BREAKPOINT_LIMIT * 0.005}px;
            font-size: ${BREAKPOINT_LIMIT * 0.0125}px;
        }
    }

    & > .right {
        display: inline-block;
        margin: 0 0 0 1.5vw;
        font-size: 4vw;
        font-weight: bold;
        vertical-align: middle;

        @media screen and (min-width: ${CONST.SCREEN.BREAKPOINT.SM}px) {
            margin-left: 0.5vw;
            font-size: 2vw;
        }

        @media screen and (min-width: ${BREAKPOINT_LIMIT}px) {
            margin-left: ${BREAKPOINT_LIMIT * 0.005}px;
            font-size: ${BREAKPOINT_LIMIT * 0.02}px;
        }
    }
`;

const StyledCarousel = styled(Carousel)`
    aspect-ratio: 1 / 1.25;
    width: 100%;
    border: 0.5vw solid ${CONST.COLOR.THEME};
    border-left: none;
    border-right: none;
    border-bottom: none;

    @media screen and (min-width: ${CONST.SCREEN.BREAKPOINT.SM}px) {
        aspect-ratio: 16 / 9;
        width: 70%;
        border: 0.05vw double ${CONST.COLOR.THEME}BD;
        border-radius: 0.5vw;
    }

    @media screen and (min-width: ${BREAKPOINT_LIMIT}px) {
        border: ${BREAKPOINT_LIMIT * 0.0005}px double ${CONST.COLOR.THEME}BD;
        border-radius: ${BREAKPOINT_LIMIT * 0.005}px;
    }

    & .header {
        background: ${CONST.COLOR.THEME_LIGHT}7D;
        border-bottom: 1px solid ${CONST.COLOR.THEME}7D;

        @media screen and (min-width: ${CONST.SCREEN.BREAKPOINT.SM}px) {
            padding: 1.5vw;
        }

        & > p {
            color: ${CONST.COLOR.THEME};
            font-size: 6vw;

            @media screen and (min-width: ${CONST.SCREEN.BREAKPOINT.SM}px) {
                font-size: 3.5vw;
            }
        }
    }

    & .arrow {
        @media screen and (min-width: ${CONST.SCREEN.BREAKPOINT.SM}px) {
            width: 4%;
        }
    }
`;

const Home = () => {
    /**************************************************************
     * HOOKS
     *************************************************************/

    /**************************************************************
     * CORE
     *************************************************************/

    return (
        <StyledContainer fluid className="p-0 m-0">
            <ContentRow className="g-0 justify-content-around">
                <Col xs={12} sm={12} xl={12} className="p-0 m-0 position-relative">
                    <StyledImage src={imgHome} />
                    <FooterText>
                        <p className="left">상담문의</p>
                        <p className="right">{CONST.PHONE}</p>
                    </FooterText>
                </Col>
            </ContentRow>
            <SlideRow className="g-0">
                <StyledCarousel
                    slides={[
                        { image: imgSlide1, text: '투시도' },
                        { image: imgSlide2, text: '투시도 측면' },
                        { image: imgSlide3, text: '반조감도' },
                        { image: imgSlide4, text: '테라스 7F' },
                        { image: imgSlide5, text: '테라스 16~18F' },
                        { image: imgSlide6, text: '로비 1F' },
                        { image: imgSlide7, text: '로비 1F' },
                        { image: imgSlide8, text: '커뮤니티 B1' },
                        { image: imgSlide9, text: '커뮤니티 B1' },
                        { image: imgSlide10, text: '커뮤니티 B1' },
                        { image: imgSlide11, text: '커뮤니티 B1' },
                        { image: imgSlide12, text: '커뮤니티 B1' },
                        { image: imgSlide13, text: '커뮤니티 B1' },
                    ]}
                />
            </SlideRow>
            <Background />
        </StyledContainer>
    );
};

export default Home;
